import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { globalActions } from 'redux/global/global.slice';
import { RootState } from 'redux/store';

export function useSpinnerLoading(name: string, loading: boolean) {
    const dispatch = useDispatch();
    const spinnerLoading = useSelector((state: RootState) => state.global.spinnerLoading);
    useEffect(() => {
        if (loading) {
            if (!spinnerLoading.includes(name)) {
                dispatch(globalActions.setSpinnerLoading([...spinnerLoading, name]));
            }
        } else {
            if (spinnerLoading.includes(name)) {
                dispatch(globalActions.setSpinnerLoading(spinnerLoading.filter((item) => item !== name)));
            }
        }
    }, [name, loading, spinnerLoading, dispatch]);

    return spinnerLoading;
}
